/* Sticker product page: pack cards, delivery date, and the summary bar along the bottom. */
(function () {
  'use strict';
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var gbp = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
  function money(p) { return gbp.format(p).replace('.00', ''); }

  // The designer builds its own preview; show it in the left column, and put the packs and the
  // Add to Cart button inside step 3 where they belong.
  function place() {
    document.querySelectorAll('[data-ssc][data-preview-into]').forEach(function (r) {
      var into = document.querySelector(r.getAttribute('data-preview-into')), p = r.querySelector('.ssc__preview');
      if (into && p) into.appendChild(p);
      var form = r.closest('form'); if (!form) return;
      var packs = form.querySelector('[data-packs]'), buy = form.querySelector('[data-buybox]');
      var s1 = r.querySelector('[data-ssc-slot="checkout"]'), s2 = r.querySelector('[data-ssc-slot="buy"]');
      if (packs && s1) s1.appendChild(packs);
      if (buy && s2) s2.appendChild(buy);
    });
  }

  function page(root) {
    var form = root.querySelector('form'); if (!form) return;
    var radios = form.querySelectorAll('input[name="id"]'), plans = form.querySelectorAll('input[name="selling_plan"]');
    // subscribe & save: the chosen plan's % off comes off every pack price shown
    function plan() { var p = form.querySelector('input[name="selling_plan"]:checked'); return p && p.value ? p : null; }
    function factor() { var p = plan(); return p ? 1 - (parseFloat(p.getAttribute('data-off')) || 0) / 100 : 1; }
    function cards() {
      var base = 0, k = factor();
      radios.forEach(function (r, i) {
        var ex = parseInt(r.getAttribute('data-price'), 10) / 120 * k, per = parseInt(r.getAttribute('data-per'), 10) || 1, each = ex / per;
        if (i === 0) base = each / k;
        var card = r.closest('.clsp__pack');
        card.querySelector('[data-ex]').textContent = money(Math.round(ex * 100) / 100);
        var save = base ? Math.round((1 - each / base) * 100) : 0;
        card.querySelector('[data-each]').textContent = Math.round(each * 100) + 'p each' + (save >= 5 ? '  ·  save ' + save + '%' : '');
      });
    }
    cards();

    // Soonest possible delivery: made in N working days (Mon-Fri), then Tracked 24 (delivers Mon-Sat).
    var make = parseInt(root.getAttribute('data-make'), 10) || 1, post = parseInt(root.getAttribute('data-post'), 10) || 1, d = new Date();
    function add(n, ok) { while (n > 0) { d.setDate(d.getDate() + 1); if (ok(d.getDay())) n--; } }
    add(make, function (w) { return w > 0 && w < 6; });
    add(post, function (w) { return w > 0; });
    root.querySelectorAll('[data-deliver-date]').forEach(function (e) { e.textContent = DAYS[d.getDay()] + ' ' + d.getDate() + ' ' + MONTHS[d.getMonth()]; });

    var bar = document.querySelector('[data-bar]'), cta = bar && bar.querySelector('[data-bar-cta]');
    var price = bar && bar.querySelector('[data-bar-price]'), pack = bar && bar.querySelector('[data-bar-pack]');
    var state = { step: 1 }, sending = false;
    function selected() { var r = form.querySelector('input[name="id"]:checked'); return r || radios[0]; }
    function paint() {
      if (!bar) return;
      var r = selected(), p = plan(), ex = Math.round(parseInt(r.getAttribute('data-price'), 10) / 120 * factor() * 100) / 100;
      price.textContent = money(ex) + ' + VAT';
      pack.textContent = r.getAttribute('data-title') + (p ? '  ·  ' + p.getAttribute('data-plan') : '') + '  ·  FREE tracked delivery';
      if (!sending) cta.textContent = state.step < 3 ? 'Continue' : 'Add to Cart';
    }
    // one tap, one order: the bar locks while the cart is being filled
    document.addEventListener('ssc:sending', function () { sending = true; if (cta) { cta.disabled = true; cta.textContent = 'Adding to cart…'; } });
    document.addEventListener('ssc:idle', function () { sending = false; if (cta) cta.disabled = false; paint(); });
    radios.forEach(function (r) { r.addEventListener('change', paint); });
    plans.forEach(function (r) { r.addEventListener('change', function () { cards(); paint(); }); });
    document.addEventListener('ssc:state', function (e) { state = e.detail; paint(); watch(); });
    if (cta) cta.addEventListener('click', function () {
      var d = root.querySelector('[data-ssc]'), c = d && d.ssc; if (!c) return;
      if (c.step < 3) c.next(); else if (form.requestSubmit) form.requestSubmit(form.querySelector('.clsp__add')); else form.querySelector('.clsp__add').click();
    });

    // The bar steps aside whenever the step's own button is on screen, so there's only ever one.
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function () { vis(); }, { threshold: 0.6 }) : null, seen = new Map();
    function watch() {
      if (!io) return;
      root.querySelectorAll('.ssc__cta').forEach(function (b) { if (!seen.has(b)) { seen.set(b, false); io.observe(b); } });
    }
    function vis() {
      var any = false;
      root.querySelectorAll('.ssc__step.is-open .ssc__cta').forEach(function (b) {
        var r = b.getBoundingClientRect(); if (r.height && r.top < window.innerHeight - 40 && r.bottom > 0) any = true;
      });
      if (bar) bar.classList.toggle('is-away', any);
    }
    window.addEventListener('scroll', vis, { passive: true });
    window.addEventListener('resize', vis);
    document.addEventListener('ssc:state', function () { setTimeout(vis, 500); });
    paint();
    if (bar) setTimeout(function () { bar.classList.add('is-ready'); vis(); }, 600);
  }

  // Thumbnails under the preview: product photos, with the live design always one tap away.
  function gallery(g) {
    var photo = g.querySelector('[data-photo]'), img = g.querySelector('[data-photo-img]'); if (!photo) return;
    var stage = g.querySelector('.clsp__stage'), thumbs = g.querySelectorAll('[data-view]');
    function show(b) {
      var live = b.getAttribute('data-view') === 'live';
      thumbs.forEach(function (t) { var on = t === b; t.classList.toggle('is-on', on); t.setAttribute('aria-selected', on); });
      if (!live) { img.src = b.getAttribute('data-view'); img.alt = b.getAttribute('data-alt') || ''; }
      photo.hidden = live; stage.hidden = !live;
    }
    thumbs.forEach(function (b) { b.addEventListener('click', function () { show(b); }); });
    // the moment they change anything, show them their design again
    var designer = document.querySelector('[data-ssc]');
    if (designer) ['input', 'change', 'click'].forEach(function (ev) { designer.addEventListener(ev, function () { if (stage.hidden) show(thumbs[0]); }); });
  }

  document.addEventListener('ssc:ready', place);
  function boot() { place(); document.querySelectorAll('[data-clsp]').forEach(page); document.querySelectorAll('[data-gallery]').forEach(gallery); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
